// export const urlApi = 'http://localhost:3200' // Desenv
// export const urlApi = 'https://projetos.qualiteessence.com.br/api/hml' // Homologação
export const urlApi = 'https://projetos.qualiteessence.com.br/api' // Produção

export const impostoAtual = 0.844
